import { Signal } from 'typed-signals';
import { getLocalizedValue } from '@softgames/localization';
import type { Popup } from '../../../popups/Popup';
import type { PopupElementAnimationData } from '../../../popups/PopupAnimations';
import { UnlockBlockerPopupLayout } from '../../../../layouts/popups/UnlockBlockerPopupLayout';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export type UnlockBlockerResult = 'confirm' | 'cancel';

export interface UnlockBlockerPopupConfig {
  price: number;
}

export class UnlockBlockerPopup implements Popup {
  private readonly layout = new UnlockBlockerPopupLayout();

  public readonly onResult = new Signal<(unlock: boolean) => void>();

  public readonly onConfirm = new Signal();

  public readonly onCancel = new Signal();

  public readonly root = this.layout.root;

  constructor(config: UnlockBlockerPopupConfig) {
    const { coinAmount } = this.layout;

    this.layout.closeArea.on('pointertap', async () => {
      this.onResult.emit(false);
    });

    this.layout.unlockButton.root.on('pointertap', () => {
      this.onResult.emit(true);
    });

    coinAmount.text = getLocalizedValue(config.price);
  }

  public onAdded(): void {
    const { unlockButton } = this.layout;

    unlockButton.root.tweenTo({ scaleXY: 1.035 }, 800, 'quadOut', true, 0, -1, true);
  }

  public getAnimatedElements(phase: 'in' | 'out'): PopupElementAnimationData[] {
     const { content } = this.layout;

    if (phase === 'in') {
      return [
        {
          container: content,
          customAnimator: async (): Promise<void> => {
            await playLayoutAnimation(this.layout, 'Appear');
          },
        },
      ];
    }

    return [{ container: content, duration: 0 }];
  }

  public async animateHide(): Promise<void> {
    this.root.interactiveChildren = false;
    await playLayoutAnimation(this.layout, 'Disappear');
  }

  public resize(): void {
    const { height } = this.root.pixi.renderer;

    this.layout.popup.y = height * 0.5;
  }
}
